export default "__VITE_ASSET__CvaB30D9__"